var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"slider js_slider\"><div class=\"frame js_frame\"><ul class=\"slides js_slides\"><li ng-repeat=\"photoUrl in $ctrl.photos\" ng-style=\"{ &quot;background-image&quot;: &quot;url(&quot; + photoUrl + &quot;)&quot; }\" class=\"carousel-slide js_slide\"></li></ul></div><div class=\"js_prev prev\"><icon name=\"ei-chevron-left\" class=\"arrow-icon\"></icon></div><div class=\"js_next next\"><icon name=\"ei-chevron-right\" class=\"arrow-icon\"></icon></div></div><div class=\"carousel-progress text-center text-small\">{{ $ctrl.currentSlideNum }} / {{ $ctrl.totalSlidesNum }}</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/components/od-lory-carousel.jade
 ** module id = 3504
 ** module chunks = 3
 **/